// @flow
// external libs
import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'
import type { OfferStateType } from './Types/OfferStateType'
import type { ContractDraft } from '../Types/ContractTypes'
import type { ArrayFieldFormTypes } from '../Types/ArrayFieldFormType'
import type { ExpandedSpecificationDTO } from '../Types/Field'
import type QuoteInstance from '../Controllers/QuoteInstance'

/* ------------- Types and Action Creators ------------- */
const { Types, Creators } = createActions({
  contractDraftRequest: ['subProductName', 'calculatorName', 'productDescriptorValues'],
  contractDraftRequestSuccess: ['contractDraft'],
  contractDraftAcceptRequest: ['subProductName', 'calculatorName', 'contractId', 'data'],
  contractDraftAcceptRequestSuccess: ['successContent'],
  setTermsAgree: ['termsAgree'],
  createContractDraftCopy: ['contractDraftUserData', 'contractDraftSupplementaryInsurances', 'contractDraftSelectedQuote',
    'contractDraftArrayTypes', 'contractDraftCalculatorSpecification', 'oldPrice', 'contractDraftDiscounts'],
  contractRequest: ['contractId'],
  contractRequestSuccess: ['acceptedContract'],
  paymentInfoRequest: ['contractId'],
  paymentInfoRequestSuccess: ['paymentInfo'],
  sendOfferRequest: ['data', 'timeout'],
  sendOfferRequestViaCrmLoaderOff: ['data', 'email'],
  sendOfferRequestViaEmailLoaderOff: ['data', 'timeout', 'email', 'productName'],
  sendOfferRequestSuccess: null,
  sendBoOfferRequestViaEmailLoaderOff: ['data', 'email', 'productName'],
  sendBoOfferRequestSuccess: null,
  getNegotiationRequest: null,
  getNegotiationRequestSuccess: ['negotiations'],
})

export const OfferTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE: OfferStateType = Immutable({ // eslint-disable-line
  contractDraft: {},
  contractDraftUserData: {},
  contractDraftSupplementaryInsurances: {},
  contractDraftArrayTypes: {},
  contractDraftSelectedQuote: {},
  contractDraftCalculatorSpecification: {},
  contractDraftDiscounts: {},
  termsAgree: false,
  isAccepted: false,
  successContent: {},
  acceptScreenData: {},
  acceptedContract: {},
  paymentInfo: {},
  oldPrice: 0,
  negotiations: [],
})

/* ------------- Reducers ------------- */

const contractDraftRequestSuccessR = (state: OfferStateType, { contractDraft }: { contractDraft: ContractDraft }): OfferStateType =>
  state.merge({ contractDraft, isAccepted: false })

const setTermsAgreeR = (state: OfferStateType, { termsAgree }: { termsAgree: boolean }): OfferStateType =>
  state.merge({ termsAgree })

const createContractDraftCopyR = (state: OfferStateType, {
  contractDraftUserData, contractDraftSupplementaryInsurances, contractDraftSelectedQuote, contractDraftArrayTypes,
  contractDraftCalculatorSpecification, oldPrice, contractDraftDiscounts
}: {
  contractDraftUserData: { [key: string]: any }, contractDraftSupplementaryInsurances: { [key: string]: any },
  contractDraftSelectedQuote:  { [productName: string]: QuoteInstance }, contractDraftArrayTypes: ArrayFieldFormTypes,
  contractDraftCalculatorSpecification: ExpandedSpecificationDTO, oldPrice: number, contractDraftDiscounts: Object
}): OfferStateType =>
  state.merge({
    contractDraftUserData,
    contractDraftSupplementaryInsurances,
    contractDraftSelectedQuote,
    contractDraftArrayTypes,
    contractDraftCalculatorSpecification,
    oldPrice,
    contractDraftDiscounts,
  })

const contractDraftAcceptRequestSuccessR = (state: OfferStateType, { successContent }: { successContent: any }) =>
  state.merge({
    ...INITIAL_STATE,
    isAccepted: true,
    successContent,
    acceptScreenData: {
      email: state.contractDraftUserData.policyHolder.email,
      contractDraftId: state.contractDraft.id
    }
  })

const contractRequestSuccessR = (state: OfferStateType, { acceptedContract }: { acceptedContract: Object }) =>
  state.set('acceptedContract', acceptedContract)

// TODO type
const paymentInfoRequestSuccessR = (state: OfferStateType, { paymentInfo }: { paymentInfo: any }) =>
  state.set('paymentInfo', paymentInfo)

const getNegotiationSuccessR = (state: OfferStateType, { negotiations }: { negotiations: { [key: string]: string } }) =>
  state.set(
    'negotiations',
    Object.keys(negotiations).map((key) => ({ buttonText: key, text: negotiations[key], disabled: false })),
  )

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.CONTRACT_DRAFT_REQUEST]: state => state,
  [Types.CONTRACT_DRAFT_ACCEPT_REQUEST]: state => state,
  [Types.CONTRACT_DRAFT_REQUEST_SUCCESS]: contractDraftRequestSuccessR,
  [Types.SET_TERMS_AGREE]: setTermsAgreeR,
  [Types.CREATE_CONTRACT_DRAFT_COPY]: createContractDraftCopyR,
  [Types.CONTRACT_DRAFT_ACCEPT_REQUEST_SUCCESS]: contractDraftAcceptRequestSuccessR,
  [Types.CONTRACT_REQUEST]: state => state,
  [Types.CONTRACT_REQUEST_SUCCESS]: contractRequestSuccessR,
  [Types.PAYMENT_INFO_REQUEST]: state => state,
  [Types.PAYMENT_INFO_REQUEST_SUCCESS]: paymentInfoRequestSuccessR,
  [Types.SEND_OFFER_REQUEST]: state => state,
  [Types.SEND_OFFER_REQUEST_VIA_CRM_LOADER_OFF]: state => state,
  [Types.SEND_OFFER_REQUEST_VIA_EMAIL_LOADER_OFF]: state => state,
  [Types.SEND_OFFER_REQUEST_SUCCESS]: state => state,
  [Types.SEND_BO_OFFER_REQUEST_VIA_EMAIL_LOADER_OFF]: state => state,
  [Types.SEND_BO_OFFER_REQUEST_SUCCESS]: state => state,
  [Types.GET_NEGOTIATION_REQUEST]: (state) => state,
  [Types.GET_NEGOTIATION_REQUEST_SUCCESS]: getNegotiationSuccessR,
})
